<template>
  <div class="con">
    <van-action-sheet
      title="配送至"
      :closeable="true"
      :round="false"
      v-model="show"
      @close="close"
    >
      <div class="text_left">
        <div class="list_con">
          <div
            v-for="(choose, index) in chooseList"
            :key="index"
            :class="{
              colof00: chooseList.length - 1 === index
            }"
            class="font14 line_height_20 colo087 font_weight400 choose_list"
            @click="chooseClick(index)"
          >
            {{ choose.areaName }}
            <div
              v-if="chooseList.length - 1 === index"
              class="choose_line"
            ></div>
          </div>
        </div>
        <div class="select_con">
          <div
            v-for="(select, index) in selectList"
            :key="index"
            class="select_list border_top1px"
            @click="selectClick(select, index)"
          >
            <div
              :class="{ colof00: selectIndex === index }"
              class="font14 line_height_24 colo087 font_weight400"
            >
              {{ select.areaName }}
            </div>
            <img
              v-if="selectIndex === index"
              src="@/assets/common/icon_radio_24@2x.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true,
      chooseList: [{ areaName: "请选择", id: -1 }],
      selectList: [],
      selectIndex: 0,
      provinceSelectIndex: 0,
      citySelectIndex: 0,
      countySelectIndex: 0,
      chooseIndex: 0
    };
  },
  computed: {
    addressData() {
      const addressData = this.$store.getters.addressData;
      return addressData;
    }
  },
  created() {
    this.getAddressData();
  },
  mounted() {
    // console.log(this.addressData);
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    getAddressData() {
      // 获取地址数据
      this.$store
        .dispatch("mine/getAllAddress")
        .then(() => {
          this.selectList = this.addressData;
        })
        .catch(() => {});
    },
    chooseClick(index) {
      this.chooseIndex = index;
      // 点击到哪就剩哪
      this.chooseList = this.chooseList.slice(0, index);
      this.chooseList.push({ areaName: "请选择", id: -1 });
      // 修改对应的selectList的值
      if (this.chooseList.length === 1) {
        this.selectList = JSON.parse(JSON.stringify(this.addressData));
      } else if (this.chooseList.length === 2) {
        this.selectList = JSON.parse(
          JSON.stringify(this.addressData[this.provinceSelectIndex].childList)
        );
      } else if (this.chooseList.length === 3) {
        this.selectList = JSON.parse(
          JSON.stringify(
            this.addressData[this.provinceSelectIndex].childList[
              this.citySelectIndex
            ].childList
          )
        );
      }
    },
    selectClick(select, index) {
      // 点击选中颜色
      this.selectIndex = index;
      // 如果不是暂不选择，那么就替换当前的请选择
      if (select.areaName !== "暂不选择") {
        this.chooseList[this.chooseList.length - 1].areaName = select.areaName;
        this.chooseList[this.chooseList.length - 1].id = select.id;
      }
      // 点击的时候替换selectList选择器的值
      if (select.childList && select.childList.length) {
        this.selectList = JSON.parse(JSON.stringify(select.childList));
        this.chooseList.push({ areaName: "请选择", id: -1 });
      } else {
        this.show = true;
        this.$emit("closeSheet");
        this.$emit("getSelectAddress", this.chooseList);
      }
      if (this.chooseList.length === 2) {
        this.provinceSelectIndex = index;
      } else if (
        this.chooseList.length === 3 &&
        this.chooseList[this.chooseList.length - 1].areaName !== "请选择"
      ) {
        this.citySelectIndex = index;
      } else {
        this.countySelectIndex = index;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  ::v-deep .van-action-sheet__header {
    padding: 14px 10px;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    line-height: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  ::v-deep .van-action-sheet__close {
    margin-top: 10px;
    color: rgba(0, 0, 0, 0.87);
  }
  .list_con {
    display: flex;
    padding: 14px 10px 0;
    overflow-y: hidden;
    flex-wrap: nowrap;
    .choose_list {
      margin-right: 28px;
      white-space: nowrap;
    }
    .choose_line {
      margin-top: 14px;
      height: 2px;
      background: #ff2121;
      border-radius: 3px;
    }
  }
  .select_con {
    height: 240px;
    overflow-y: scroll;
    .select_list {
      display: flex;
      justify-content: space-between;
      padding: 12px 10px;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
